var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":""}},[_c('img',{staticClass:"dbutton",attrs:{"src":require("../assets/download2.svg")}})])
}]

export { render, staticRenderFns }